<template>
  <div class="transaction">
    <div v-if="success" class="content">
      <h1 class="title">
        {{ $t('TRANSACTION.SUCCESS') }}
      </h1>
      <img src="/img/transaction/img-success.svg" alt="" class="content-kv">
      <p class="desp">
        {{ $t('TRANSACTION.SUCCESS_DESP') }}
      </p>
      <div v-if="order" class="table">
        <div class="table-tr">
          <div class="table-th">
            {{ $t('TRANSACTION.TABLE_NO') }}
            <span class="info">
              {{ order.id }}
            </span>
          </div>
          <div class="table-th">
            {{ $t('TRANSACTION.TABLE_ITEM') }}
            <span class="info">
              MUZIK 訂閱會員
            </span>
          </div>
          <div class="table-th">
            {{ $t('TRANSACTION.TABLE_TIME') }}
            <span class="info">
              {{ order.created_at }}
            </span>
          </div>
          <div class="table-th">
            {{ $t('TRANSACTION.TABLE_AMOUNT') }}
            <span class="info">
              {{ order.plan_id === 1 ? '99' : '297' }} TWD
            </span>
          </div>
          <div class="table-th">
            {{ $t('TRANSACTION.TABLE_NOTE') }}
            <span class="info">
              -
            </span>
          </div>
        </div>
        <div class="table-tr">
          <div class="table-td">
            {{ order.id }}
          </div>
          <div class="table-td">
            MUZIK 訂閱會員
          </div>
          <div class="table-td">
            {{ order.created_at }}
          </div>
          <div class="table-td">
            {{ order.plan_id === 1 ? '99' : '297' }} TWD
          </div>
          <div class="table-td">
            -
          </div>
        </div>
      </div>
    </div>
    <div v-else class="content">
      <h1 class="title">
        {{ $t('TRANSACTION.FAIL') }}
      </h1>
      <img src="/img/transaction/img-unsuccess.svg" alt="" class="content-kv">
      <p class="desp" v-html="$t('TRANSACTION.FAIL_DESP')" />
    </div>
  </div>
</template>
<script>

import SubscribeService from '@/assets/services/SubscribeService'
export default {
  name: 'Transaction',
  components: {},
  directives: {},
  props: {},
  data() {
    return {
      success: true,
      order: []
    }
  },
  computed: {},
  watch: {},
  created() {},
  async mounted() {
    await this.getStatus()
  },
  updated() {},
  methods: {
    async getStatus() {
      const token = window.localStorage.getItem(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY)
      if (token) {
        const res = await SubscribeService.getSubscription(token)
        if (res && res.subscription) {
          this.success = true
          this.order = res.subscription[0]
        } else {
          this.success = false
        }
      } else {
        this.$router.push({ name: 'index', params: { locale: this.$i18n.localePath() } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.transaction {
  .content{
    width: 100%;
    padding: 0 102px;
    text-align: center;
    .title{
      font-family: NotoSansCJKtc;
      font-size: 36px;
      font-weight: 500;
      color: $grey-5a;
      margin: 64px 0 36px;
      padding: 0;
    }
    .desp{
      font-family: NotoSansCJKtc;
      font-size: 20px;
      line-height: 1.6;
      letter-spacing: -0.08px;
      color: $grey-50;
      margin-bottom: 48px;
    }
  }
  .content-kv{
    width: 100%;
    max-width: 450px;
    height: auto;
    margin-bottom: 48px;
  }
  .table{
    display: table;
    width: 100%;
    max-width: 1230px;
    margin: 0 auto 120px;
    .table-tr{
      display: table-row;
      background: $grey-f3;
      &+.table-tr{
        background: #fff;
      }
    }
    .table-th,
    .table-td{
      display: table-cell;
    }
    .table-th,
    .table-td{
      font-family: NotoSansCJKtc;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.63;
      letter-spacing: normal;
      color: $grey-9b;
      padding: 10px 36px;
    }
    .table-td{
      color: $grey-7d;
    }
    .info{
      display: none
    }
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (max-width: 1439.98px) {
  .transaction {
    .content{
      padding: 0 38px;
    }
  }
}
@media only screen and (max-width: 1023.98px) {
  .transaction {
    .table{
      .table-th,
      .table-td{
        padding: 10px 24px;
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .transaction {
    .content{
      padding: 0 24px;
      .title{
        font-size: 24px;
        margin: 24px 0 16px;
      }
      .desp{
        font-size: 16px;
      }
    }
    .table{
      text-align: left;
      .table-th,
      .table-td{
        display: block;
        padding: 10px 24px;
        padding: 8px;
      }
      .table-th:nth-child(2n){
        background: #fff;
      }
      .table-td{
        display: none;
      }
      .info{
        display: block;
      }
    }
  }
}
</style>
